import "core-js/stable";
import "regenerator-runtime/runtime";

import 'postcss';
//メインCSS読み込み
import "../scss/style.scss";

//JSライブラリ読み込み
import $ from "jquery";
import gsap from "gsap";
import ScrollMagic from "ScrollMagic";
import Swiper from 'swiper';

import {
	load,
	resize
} from './common/common';
import TopPage from './top/top';

let top_page = $('.is-top')
let contact_page = $('.page-contact')


$(function () {
	load()
	if (top_page) {
		TopPage()
	} else if (contact_page) {

	}
	$('[data-tab]').on('click', function (event) {
		event.preventDefault()
		tabChange($(this).data('tab'), $(this))
	})

	$('.js-spnavbtn').on('click', function (event) {
		if ($(this).hasClass('is-open')) {
			$(this).removeClass('is-open')
			$('.p-spnav').removeClass('is-open')
		} else {
			$(this).addClass('is-open')
			$('.p-spnav').addClass('is-open')
		}
	})
})


function tabChange(target_tab_name, nav_target_el) {
	nav_target_el.siblings().removeClass('is-active');
	nav_target_el.addClass('is-active');
	$('[data-tab-target].is-active').removeClass('is-active');
	$('[data-tab-target="' + target_tab_name + '"]').addClass('is-active');
}